import { render, staticRenderFns } from "./VideoTutorialModal.vue?vue&type=template&id=1ddd6600&scoped=true&"
import script from "./VideoTutorialModal.vue?vue&type=script&lang=ts&"
export * from "./VideoTutorialModal.vue?vue&type=script&lang=ts&"
import style0 from "./VideoTutorialModal.vue?vue&type=style&index=0&id=1ddd6600&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd6600",
  null
  
)

export default component.exports